import React from 'react'

export default function Footer() {
  return (
    <div className='w-full bg-cover relative disableDrag'>
      <div className='text-white text-[12px] absolute bottom-0 pl-[120px] sm2:pl-[250px] lg:pl-[300px] pb-2 w-full text-center sm2:text-start'>
        
      </div>
    </div>
  )
}
